import { RouteObject } from "react-router-dom"
import AuthGuard from "../../../shared/auth/component/auth"
import NewParkingLotComponent from "../component/new-parking-activity-component"
import ParkingPage from "../page/parking-activity.page"
import ParkingActivityPage from "../page/parking-activity.page"
import NewParkingActivityComponent from "../component/new-parking-activity-component"
import MinifiedParkingActivityPage from "../page/portal-parking-activity.page"
export const ParkingActivityRoute: RouteObject = {
  path: "/parking-activity",
  element: (
    <AuthGuard role={["super_admin", "owner"]} permission={["manage-parking", "view-parking"]}>
      <ParkingActivityPage />
    </AuthGuard>
  ),
  children: [
    {
      path: "detail/:type/:id",
      element: <NewParkingActivityComponent editMode="detail" />,
    },
    
    { path: ":id", element: <NewParkingActivityComponent editMode="new" /> },
  ],
}

export const SimpleParkingActivityRoute: RouteObject = {path: "parking-activity/simple/:id", element: <MinifiedParkingActivityPage />}
